import { motion } from "framer-motion";
import { forwardRef } from "react";
import { ArrowRightIcon, ShoppingBagIcon } from "../../utils/icons";

const Button = forwardRef(
  (
    {
      children,
      variant = "primary",
      size = "md",
      fullWidth = false,
      disabled = false,
      className = "",
      loading = false,
      ...props
    },
    ref
  ) => {
    const baseStyles =
      "inline-flex items-center justify-center font-medium rounded-full transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2";

    const variants = {
      primary:
        "bg-[#DB5461] text-white hover:bg-[#DB5461]/90 focus:ring-[#DB5461]",
      secondary: "bg-gold-500 text-black hover:bg-gold-400 focus:ring-gold-400",
      outline:
        "border-2 border-[#DB5461] text-[#DB5461] hover:bg-[#DB5461] hover:text-white focus:ring-[#DB5461]",
      ghost: "text-[#DB5461] hover:bg-[#DB5461]/10 focus:ring-[#DB5461]",
    };

    const sizes = {
      sm: "px-4 py-2 text-sm",
      md: "px-6 py-3 text-base",
      lg: "px-8 py-4 text-lg",
    };

    const loadingSpinner = (
      <svg
        className="animate-spin -ml-1 mr-3 h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    );

    const classes = [
      baseStyles,
      variants[variant],
      sizes[size],
      fullWidth ? "w-full" : "",
      disabled ? "opacity-50 cursor-not-allowed" : "",
      className,
    ].join(" ");

    return (
      <motion.button
        ref={ref}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        className={`${classes} ${
          loading ? "opacity-50 cursor-not-allowed" : ""
        }`}
        disabled={disabled || loading}
        {...props}
      >
        {loading && loadingSpinner}
        {children}
      </motion.button>
    );
  }
);

Button.displayName = "Button";

export default Button;
